import axios from "axios";
import API_BASE_URL from '../../config';

export const GetProgressCourseServices = async (token, idUser, idCourse) => {
  try {
    if (!token) {
      throw new Error("No token available");
    }

    const responseCourses = await axios.get(`${ API_BASE_URL }api/get-progress-user-course/`,
        {
          params: {
            user_id: idUser,
            course_id: idCourse,
          },
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }
    )
  
    console.log(responseCourses.data)
    return responseCourses.data;


    } catch (error) {
      console.error('Error en la solicitud:', error.response ? error.response.data : error.message);
      throw error;
    }
};